
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/purchase-history",
      function () {
        return require("private-next-pages/purchase-history/index.tsx");
      }
    ]);
  